export default __webpack_public_path__ + "static/logo_header-b237e2eea497c86a7ef13b9dc9306e31.svg";